import { Injectable } from '@angular/core';
import { HttpReserveProvider } from '../providers/http-reserve';
import { AuthStore } from '../stores/auth-store';
import { ChildAction } from '../actions/child.action';

import _ from 'underscore';
import Utils from '../_com/utils';

/**
 * Generated class for the FamilyPage page.
 *
 * See http://ionicframework.com/docs/components/#navigation for more info
 * on Ionic pages and navigation.
 */

@Injectable()
export class ReserveAction {

  constructor(
		private httpReserveProvider:HttpReserveProvider,
    private authStore:AuthStore,
    private childAction:ChildAction,
  	) {
  }

  /**
   * 予約時の日付初期設定情報を取得する
   */
  getInitialReserveDate(): Date {
    var s = new Date();
    // s.setDate(s.getDate() + 2); //2日後
    return s;
  }
  /**
   * 予約時の日付を複数設定可能にする
   */
  getInitialReserveMulthDate(): any {
    var s = new Date();
    // s.setDate(s.getDate() + 2); //2日後
    return [s];
  }

  /**
   * 予約時の時間初期設定情報を取得する
   */
  getInitialReserveTime(){

    var s = new Date();
    s.setHours(9);
    s.setMinutes(0);
    var e = new Date();
    e.setHours(11);
    e.setMinutes(0);
    return [s, e];
  }

  /**
   * 入力された日付・時間を、検索可能なデータ形式を追加する
   */
  mergeSearchableDatetime(datetime){

    datetime.date = Utils.date.format(datetime.input.date, "yyyy-MM-dd");
    datetime.time = [Utils.date.format(datetime.input.time[0], "HH:mm"), Utils.date.format(datetime.input.time[1], "HH:mm")];
  }

  mergeElapsedTime(datetime){

    var s = Utils.time.minuteDistance(datetime.input.time[0], datetime.input.time[1]);
    datetime.elapsed = s;
  }

  /**
   * 登録処理（新規・更新含む）
   */
  save(data){

    //スタッフID
    data.staff = this.authStore.logedIn["id"];

    //月齢情報をマージする
    this.mergeChildOfAgeIntoReserveData(data.children, data.datetime.input.date);

    //予約時間を算出する
    this.mergeElapsedTime(data.datetime);

    //検索用の日付・時間データを付与する
    this.mergeSearchableDatetime(data.datetime);

    return this.httpReserveProvider.save(data);
  }

  /**
   * 登録処理（新規・更新含む）
   */
  saveInterviewSheet(data) {
    return this.httpReserveProvider.saveInterviewSheet(data);
  }

  /**
   * 体調不良・怪我連絡（怪我報告書・体調管理票の置き換え）　取得
   */
  getNotebookData(condition) {
    return this.httpReserveProvider.getNotebookData(condition);
  }
  /**
   * 体調不良・怪我連絡（怪我報告書・体調管理票の置き換え）　登録・更新処理
   */
  saveNotebook(data) {
    return this.httpReserveProvider.saveNotebook(data);
  }

  /**
   * 写真リクエストへの返信
   */
  replyPhotoRequest(data){

    return this.httpReserveProvider.replyPhotoRequest(data);
  }

  /**
   * 一覧取得
   */
  getList(conditons){

    if(conditons["date"]){
      conditons["date"] = Utils.date.format(conditons["date"], "yyyy-MM-dd");
    }
    return this.httpReserveProvider.getList(conditons);
  }

  /**
   * 問診票一覧取得
   */
  getInterviewData(condition) {
    // なんか条件追加する必要あればここで追加する
    return this.httpReserveProvider.getInterviewData(condition);
  }

  /**
   * お迎え情報取得
   */
  getPickupData(condition) {
    // なんか条件追加する必要あればここで追加する
    return this.httpReserveProvider.getPickupData(condition);
  }

  /**
   * 写真リクエスト返信可能状態にする
   */
  toEnablePhotoRequestReply(id){

    return this.httpReserveProvider.toEnablePhotoRequestReply({id:id});
  }

  /**
   * 写真リクエスト一覧取得
   */
  getListPhotoRequest(needLoading: boolean = true){

    return this.httpReserveProvider.getList({ photoRequest: true, needLoading: needLoading});
  }

  /**
   * 予約リクエスト一覧取得
   */
  getListReserveRequest(needLoading: boolean = true) {

    return this.httpReserveProvider.getList({ reserveRequest: true, needLoading: needLoading});
  }

  /**
   * ステータス変更
   */
  private changeStatus(reserveId, status){

    var data = {id:reserveId, status:status};
    return this.httpReserveProvider.changeStatus(data);
  }

  /**
   * 写真リクエスト・メッセージを更新する
   */
  updatePhotoRequestMessage(reserveId, message){

    var data = {id:reserveId, message:message};
    return this.httpReserveProvider.updatePhotoRequestMessage(data);
  }

  /**
   * 予約をキャンセルする
   */
  reserveCancel(reserveId){

    return this.changeStatus(reserveId, 1);
  }

  /**
   * 予約リクエストを承認する
   */
  reserveRequestAccept(reserveId){

    return this.changeStatus(reserveId, 0);
  }

  /**
   * 予約リクエストを却下する
   */
  reserveRequestRejection(reserveId){

    return this.changeStatus(reserveId, 3);
  }

  /**
   * 予約リクエストを保留状態する
   */
  reserveRequestHold(reserveId){

    return this.changeStatus(reserveId, 4);
  }

  /**
   * 予約情報へ子供の月齢情報をマージする
   */
  mergeChildOfAgeIntoReserveData(children:any[], resereveDate:Date = new Date()){

    return _.chain(children)
            .map(data=>{
              if((!_.isNull(data)) && (!_.isUndefined(data["birthday"]))){
                var childAfAge = this.childAction.calcChildOfAge(data["birthday"], resereveDate);
                data["childOfAge"] = childAfAge;
              }
              return data;
            })
            .value();
  }

  /**
   * 予約IDの配列を作成する
   */
  getReserveIds(reserves){

    return _.chain(reserves)
            .filter((data)=>{
              return true
            })
            .map((data)=>{
              return data["Reserve"]["id"];
            })
            .value();
  }
}



// WEBPACK FOOTER //
// ./src/actions/reserve.action.ts